<template>
  <div class="ima-preloader">
    <b-loading :active="true"></b-loading>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { fetchInitialData } from '@/store/actions'

export default {
  name: 'ima-preloader',
  data () {
    return {}
  },
  methods: {
    ...mapActions([fetchInitialData])
  },
  created () {
    this.fetchInitialData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Preloader.vue